export default __webpack_public_path__ + "static/media/access.7ed68915.png";